module.exports = __webpack_public_path__ + "img/53.efbe5343.jpg";